<script lang="ts">
    import {availableQualifications} from "$lib/calls/qualification";
    import {EditWorkEntries, ReadAssignments, ReadWorkEntries} from "$lib/utils/tableHeaders/workentries";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import AddButton from "$lib/components/ui/AddButton.svelte";
    import {addWorkEntry, deleteWorkEntry, updateWorkEntry} from "$lib/calls/workEntry";
    import {getProject} from "$lib/calls/project";
    import {createInfo} from "$lib/calls/timeline";
    import DateDisplay from "$lib/components/ui/DateDisplay.svelte";

    export let project;

    let showWorkentryWizard = false;

    let reactiveHeader = {
        async delete(index) {
            if (typeof project.workEntries[index].uuid !== 'undefined') {
                await deleteWorkEntry(project, project.workEntries[index])
            }
            project.workEntries = project.workEntries.filter((x: any, i: number) => i !== index)
        }
    }
    const updateWorkEntries = async () => {
        showWorkentryWizard = false;
        for (let i = 0; i < project.workEntries.length; i++) {
            project.workEntries[i].startsAt = typeof project.workEntries[i].startsAt.value !== 'undefined' ? project.workEntries[i].startsAt.value : project.workEntries[i].startsAt
            project.workEntries[i].endsAt = typeof project.workEntries[i].endsAt.value !== 'undefined' ? project.workEntries[i].endsAt.value : project.workEntries[i].endsAt
            if (typeof project.workEntries[i].uuid !== 'undefined') {
                await updateWorkEntry(project, project.workEntries[i])
            } else {
                await addWorkEntry(project, project.workEntries[i])
            }
        }
        await createInfo(project, 'Personalanforderungen wurden aktualisiert!', 'Das angefragte Personal wurde geändert!')
        project = await getProject(project.uuid)

    }
    let workEntriesCopy;
    const toggleWorkentryWizard = () => {
        if (!showWorkentryWizard) {
            workEntriesCopy = [...project.workEntries]
        } else {
            project.workEntries = workEntriesCopy
        }
        showWorkentryWizard = !showWorkentryWizard
    }


</script>
{#await availableQualifications() then qualifications}
    <div class="">
        {#if !showWorkentryWizard && project.status === 'requested'}
            <div class="px-1">
                <SortableTable data={project.workEntries} header={ReadWorkEntries(qualifications)}/>
            </div>
        {:else if !showWorkentryWizard}
            {#each project.workEntries as workEntry}
                <div class="flex gap-3 text-neutral-700 px-2">
                    <DateDisplay value={workEntry.startsAt}/>
                    <p class="flex-1">{qualifications.find(x => x.id === workEntry.qualificationId).title}</p>
                    <p class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                        Expected: {workEntry.amount}</p>
                </div>
                <SortableTable emptyText="No assignee" hideHeader={false} data={workEntry.assignments}
                               header={ReadAssignments(project, workEntry.assignments)}>

                </SortableTable>
            {/each}
        {:else}
            <form on:submit|preventDefault={updateWorkEntries}>
                <SortableTable bind:data={project.workEntries}
                               header={EditWorkEntries(qualifications, project, reactiveHeader)}/>
                <div class="grid grid-cols-2 gap-3 my-5 pr-8">
                    <div>
                        <button type="submit"
                                class="inline-flex items-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
                            Änderungen speichern
                        </button>
                    </div>
                    <AddButton classes="place-self-end"
                               onClick={() => project.workEntries = [...project.workEntries, {amount: 1, startsAt:project.workEntries[0].startsAt, endsAt:project.workEntries[0].endsAt}]}/>
                </div>
            </form>
        {/if}
    </div>
{/await}